const OAUTH_PARAMS = ["oauth", "provider", "error"];

export function removeOAuthCallbackParams(locationLike) {
  const href = typeof locationLike === "string"
    ? locationLike
    : locationLike?.href || "/";
  const url = new URL(href, "https://optimus.local");
  OAUTH_PARAMS.forEach((param) => url.searchParams.delete(param));
  return `${url.pathname}${url.search}${url.hash}`;
}
